import TripChatDesktopSurface, { type TripChatDesktopSurfaceProps } from './surfaces/TripChatDesktopSurface'
import TripChatMobileSurface, { type TripChatMobileSurfaceProps } from './surfaces/TripChatMobileSurface'

export type TripChatSurface = 'desktop' | 'mobile'

type TripChatSurfaceRouterProps =
  | { surface: 'desktop'; desktopSurfaceProps: TripChatDesktopSurfaceProps }
  | { surface: 'mobile'; mobileSurfaceProps: TripChatMobileSurfaceProps }

function TripChatSurfaceRouter(props: TripChatSurfaceRouterProps) {
  if (props.surface === 'mobile') {
    return <TripChatMobileSurface {...props.mobileSurfaceProps} />
  }
  const { desktopSurfaceProps } = props
  return <TripChatDesktopSurface {...desktopSurfaceProps} />
}

export default TripChatSurfaceRouter
